module.exports = __webpack_public_path__ + "static/media/camida.301f890c.png";